import React from 'react'
import LoadingSpinner from '../leevo_ui/LoadingSpinner/LoadingSpinner'

function LoadingConversations() {
  return (
    <div className="flex items-center justify-center h-full">
      <LoadingSpinner size="1/5" color="purple" />
    </div>
  )
}

export default LoadingConversations
